import React, { createContext, useContext, useMemo, useState } from 'react';
import { getUser } from '@/lib/common';

type CurrencyMode = 'user' | 'budget';

interface CurrencyContextType {
  selectedCurrencyMode: CurrencyMode;
  setSelectedCurrencyMode: (mode: CurrencyMode) => void;
  getDisplayCurrency: (budgetCurrency?: string) => string;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined,
);

export const CurrencyProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [selectedCurrencyMode, setSelectedCurrencyMode] = useState<CurrencyMode>(
    'user',
  );
  const user = getUser();

  const contextValue = useMemo<CurrencyContextType>(() => {
    const getDisplayCurrency = (budgetCurrency?: string) => {
      if (selectedCurrencyMode === 'budget' && budgetCurrency) {
        return budgetCurrency;
      }
      return user?.default_currency || 'USD';
    };

    return {
      selectedCurrencyMode,
      setSelectedCurrencyMode,
      getDisplayCurrency,
    };
  }, [selectedCurrencyMode, user?.default_currency]);

  return (
    <CurrencyContext.Provider value={contextValue}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};


